






























































































































































    import { Component, RightHelper } from "../../../Infrastructure/CorBase/CoreBase";
    import RoleDetailBase from "./RoleDetailBase";
   
	@Component
	export default class RoleDetail extends RoleDetailBase {
        created() {
            super.created();      
            super.setMainDescription('role.newRole','role.description');		
        }

        

        disableAddButton() {
            return this.formData.id == 0;
        }

        saveRoleTitle() {
            return RightHelper.currentUserIsSuperUser() ? this.$t('global.buttonSave') : "";
        }

        goBackNotChangeOwn() {
            this.goBackNotChangeOwnBase();
        }

        cancelRoleTitle() {
            return RightHelper.currentUserIsSuperUser() ? this.$t('global.buttonCancel') : "";
        }

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && ((this.formIsInEditMode && this.dataWasChanged()) || this.mainDataChangedSub)) {
                event.preventDefault();  event.returnValue = "";
            }
        }

        beforeMount() {           
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {      
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);          
            this.$store.commit("mainDataChanged", false);
        }

		mounted() {
            super.mounted();          
		};

		modalContentDelete() {
			return this.modalContentDeleteBase();
		}

		protected showSaveAll(): boolean {
			return this.showSaveAllBase;
		}

		protected isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}

		selectedRightItems(selected: any): void {
			this.selectedRightItemsBase(selected);
		}

		private deleteRight(item: any): void {
			this.deleteRightBase(item);
		}

		private addNewRight(): void {
			this.addNewRightBase();
		}

		private rightNotChanged(): boolean {
         
            this.mainDataChangedSub = !this.rightNotChangeBase();
			return this.rightNotChangeBase();
		}

        private goBackRight(): void {
            this.mainDataChangedSub = false;
			this.goBackRightBase();
		}

		private saveChangeRight(): void {
			this.saveChangeRightBase();
		}

		///hlaska o prekroceni inputu po Ctrl+V
		protected infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
        }

       
	}
